import React, { useMemo } from 'react';
import { StyledRadioGroup } from '../../../../common/RadioGroup';
import ExceptionNumberInput from '../common/ExceptionNumberInput';

const ADEExceptionFlow = ({
  classes,
  DispatchStore,
  editInfo,
  onChange,
  isDeliveryException,
  maxExceptionNumberLength, // for input maxLength; min is only used in validation (utils)
  exceptionNumberLabel
}) => {
  const exception = useMemo(() => {
    return editInfo.exception?.length > 0 ? editInfo.exception[0] : {};
  }, [editInfo.exception]);

  const shouldShowADENumberInput = useMemo(() => {
    // Determines whether to display the ADE Number input field:
    // - For Delivery Exception: display only if an exception type has been selected.
    // - For Return Exception: always display, since this component is rendered only if a return code is selected.
    return !isDeliveryException || exception?.code;
  }, [isDeliveryException, exception?.code]);

  const exceptionTypeOptions = DispatchStore.exceptions || [];

  const handleChange = (name) => (value) => {
    //Since only one exception is allowed for ADE flow, we are using index 0
    onChange && onChange(0)(name)(value);
  };

  const handleADENumberChange = (value) => {
    handleChange('adeNumber')(value);
  };

  const errorInfo = useMemo(() => exception.errorInfo, [exception.errorInfo]);

  return (
    <div>
      {isDeliveryException && (
        <StyledRadioGroup
          onChange={handleChange('code')}
          options={exceptionTypeOptions}
          helperText={errorInfo.code}
          error={Boolean(errorInfo.code)}
          value={exception.code}
        />
      )}
      {shouldShowADENumberInput && (
        <>
          <ExceptionNumberInput
            classes={classes}
            label={exceptionNumberLabel}
            value={exception.adeNumber}
            onChange={handleADENumberChange}
            error={errorInfo.adeNumber}
            maxLength={maxExceptionNumberLength}
          />
        </>
      )}
    </div>
  );
};

export default ADEExceptionFlow;
